export default "__VITE_ASSET__CETr39z0__"